import { createFileRoute } from "@tanstack/react-router"
import { VideoStoryboardPageWrapper } from "./-StoryboardPage"

export const Route = createFileRoute("/videos/$videoId/storyboard")({
  component: VideoStoryboardPageWrapper,
})
